export default () => ({
    detail: null,
    detailError: null,
    detailLoading: false,
})